/**************
 Cart
 ***************/

// free bottle variant - never allowed to sit in the cart as a real line item, even if added directly
const FREE_BOTTLE_VARIANT_ID = 49771262181603;

// open cart
async function openCart(skipFetch = false) {
    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // get cart item data
    const cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());

    // remove protection or free containers
    if (cartSettings.protection_upsell) {
        // create update payload
        let updatePayload = {};

        // get all protection items
        cart.items.forEach(item => {
            if (item.variant_id === cartSettings.protection_upsell.variants[0].id) {
                updatePayload[item.key] = 0;
            }
        });

        // check if we need to update the cart
        if (Object.keys(updatePayload).length > 0) {
            cart = await updateCart({updates: updatePayload});
            await openCart(true);
            return;
        }
    }

    // remove free gift line items - they're only attached at checkout and never shown as real cart items
    let giftPayload = {};
    cart.items.forEach(item => {
        if (item.properties?._free || item.variant_id === FREE_BOTTLE_VARIANT_ID) {
            giftPayload[item.key] = 0;
        }
    });

    // check if we need to update the cart
    if (Object.keys(giftPayload).length > 0) {
        cart = await updateCart({updates: giftPayload});
        await openCart(true);
        return;
    }

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    // document.querySelector('#headerIconsCart').setAttribute("data-count", cart.item_count);
    document.querySelector('.headerControlsLinkDesktop.cart').textContent = `CART (${cart.item_count})`;
    document.querySelector('.headerControlsLink.openCart').setAttribute("aria-label", `cart (${cart.item_count})`);
    document.querySelector("#miniCartHeaderTitle").textContent = `${cart.item_count} ITEM${cart.item_count !== 1 ? "S" : ""}`;

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartHeader").classList.remove("active");
        document.querySelector("#miniCartWrap").classList.remove("active");
        document.querySelector("#miniCartUpsell").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartWrap").classList.add("active");
    document.querySelector("#miniCartUpsell").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach(item => {
        if (item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    // Free shipping for subscription
    if (cartSettings.free_shipping_method === "subscription") {
        if (subscriptionItems > 0) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBar").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "Upgrade to a subscription for <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBar").classList.remove("active");
        }
    }

    // Free shipping for price threshold
    if (cartSettings.free_shipping_method === "threshold") {

        // Free shipping is always given on subscriptions
        if (subscriptionItems > 0) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBar").classList.add("active");
        } else {
            let freeShippingThreshold = parseInt(cartSettings.free_shipping_threshold * 100);
            if (cart.total_price >= freeShippingThreshold) {
                document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked free shipping";
                document.querySelector("#miniCartHeaderBar").classList.add("active");
            } else {
                document.querySelector("#miniCartHeaderShipping").innerHTML = `Spend ${price(freeShippingThreshold - cart.total_price, true)} more for free shipping`;
                document.querySelector("#miniCartHeaderBarInner").style.width = `${(cart.total_price / freeShippingThreshold) * 100}%`;
                document.querySelector("#miniCartHeaderBar").classList.remove("active");
            }
        }
    }

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());
    document.querySelectorAll(".miniCartBodyGift").forEach(element => element.remove());

    // append cart
    cart.items.forEach(function (item) {
        // save supplement data
        const supplementData = cartData[item.key];

        // determine if item has properties - keys starting with _ are hidden, so they don't count
        const visibleProperties = Object.keys(item.properties || {}).filter(key => !key.startsWith("_"));
        const hasProperties = visibleProperties.length > 0;

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key of visibleProperties) {
                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // discount HTML
        function discountHTML() {
            let HTML = "";

            // check for discount
            if (item.line_level_discount_allocations.length === 0) {
                return "";
            }

            item.line_level_discount_allocations.forEach(discount => {
                HTML = `<div class="miniCartBodyItemDiscount">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"/><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"/></svg>
                            ${discount.discount_application.title}
                         </div>`;
            });

            return HTML;
        }

        // price HTML
        function priceHTML() {
            let HTML = price(item.final_line_price, true);

            // there are 3 types of compare at prices (selling_plan_allocation, line item discount, compare at price)
            // calculate all 3 and the greatest one will be displayed if it is greater than the final line price
            const comparePrices = [];

            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrices.push(item.selling_plan_allocation.compare_at_price * item.quantity);
            }

            // check for line item discount
            if (item.original_line_price > item.final_line_price) {
                comparePrices.push(item.original_line_price);
            }

            // check for compare at price
            if (supplementData.compare_at_price) {
                comparePrices.push(supplementData.compare_at_price * item.quantity);
            }

            // if there is at least one compare price
            // compare price currently disabled
            if (comparePrices.length > 0 && false) {
                // find the greatest compare price
                const greatestComparePrice = Math.max(...comparePrices);

                // check if the greatest compare price is greater than the final line price
                if (greatestComparePrice > item.final_line_price) {
                    HTML += `
                        <s>${price(greatestComparePrice, true)}</s>
                    `;
                }
            }

            return HTML;
        }

        /**
         * Calculate save percentage, preferring the variant's quantity selector metafield (sub_price_cents vs sub_compare_cents)
         * so the cart matches the PDP cards, falling back to the plan's price adjustment (percentage, fixed_amount, price)
         * against the base price (compare at price or original price)
         * @param plan
         * @returns {number|*|string}
         */
        function calcSavePercent(plan) {
            // discounts can split the same variant across multiple lines - sum its quantity across the whole cart
            let variantQuantity = 0;
            cart.items.forEach(cartItem => {
                if (cartItem.variant_id !== item.variant_id) {
                    return;
                }
                variantQuantity += cartItem.quantity;
            });

            // prefer the quantity selector matching the variant's total quantity - same math as the PDP save badge
            let selector = supplementData.quantity_selectors?.find(q => parseInt(q.quantity) === variantQuantity);

            // no exact match and the quantity exceeds every selector - use the highest one (e.g. 4 in cart, selectors stop at 3)
            if (!selector && supplementData.quantity_selectors?.length) {
                const highestSelector = supplementData.quantity_selectors.reduce((highest, q) => parseInt(q.quantity) > parseInt(highest.quantity) ? q : highest);
                if (variantQuantity > parseInt(highestSelector.quantity)) {
                    selector = highestSelector;
                }
            }
            if (selector && selector.sub_price_cents !== null && selector.sub_compare_cents !== null && selector.sub_compare_cents > selector.sub_price_cents) {
                return Math.round((1 - selector.sub_price_cents / selector.sub_compare_cents) * 100);
            }

            // fallback: derive the percent from the selling plan's first price adjustment
            if (!plan.price_adjustments || plan.price_adjustments.length === 0) return '';
            const adjustment = plan.price_adjustments[0];

            // find the best base price (same logic as priceHTML compare prices)
            const basePrices = [item.original_price];
            if (item.selling_plan_allocation?.compare_at_price) basePrices.push(item.selling_plan_allocation.compare_at_price);
            if (supplementData.compare_at_price) basePrices.push(supplementData.compare_at_price);
            const basePrice = Math.max(...basePrices);

            if (adjustment.value_type === 'percentage') return adjustment.value;
            if (basePrice > 0 && adjustment.value_type === 'fixed_amount') return Math.round((adjustment.value / basePrice) * 100);
            if (basePrice > 0 && adjustment.value_type === 'price') return Math.round(((basePrice - adjustment.value) / basePrice) * 100);
            return '';
        }

        // upgrade button HTML
        function upgradeHTML() {
            // already subscribed, only show the frequency selector so the plan can't be removed
            if (item.selling_plan_allocation) {
                const sellingPlans = supplementData["selling_plan_allocations"];
                const currentPlan = item.selling_plan_allocation.selling_plan;

                // Create options for other plans
                const optionsHTML = sellingPlans.map(plan =>
                    `<option value="${plan.id}" ${plan.id === currentPlan.id ? 'selected' : ''}>${plan.name}</option>`
                ).join('');

                return `
                     <div
                        class="miniCartBodyItemPlan"
                        >
                        <span class="miniCartBodyItemPlanFrequency">
                            <span class="miniCartBodyItemPlanFrequencyTitle">Deliver every:</span>
                            <select class="miniCartBodyItemPlanFrequencySelect" data-key="${item.key}" data-quantity="${item.quantity}" aria-label="Frequency">
                            ${optionsHTML}
                            </select>
                        </span>
                    </div>
                `;
            }

            // no subscription — show upgrade button
            const sellingPlan = supplementData["selling_plan"];
            if (!sellingPlan) return "";

            const savePercent = calcSavePercent(sellingPlan);

            return `
                <button 
                    class="miniCartBodyItemPlan planUpgrade"
                     data-key="${item.key}"
                     data-quantity="${item.quantity}" 
                     data-plan="${sellingPlan.id}"
                >
                    <span class="miniCartBodyItemPlanWrap">
                        <span class="miniCartBodyItemPlanBox"></span>
                        <span class="miniCartBodyItemPlanTxt">Subscribe to get ${savePercent}% off</span>
                    </span>
                </button>
            `;
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" data-key="${item.key}">
                <img class="miniCartBodyItemImage" src="${item.image}&width=200" alt="${item.product_title}">
                <div>
                    <div class="miniCartBodyItemFlex">
                        <div>
                            <div class="miniCartBodyItemTitle">${item.product_title}</div>
                            ${variantHTML()}
                            ${propertiesHTML()}
                        </div>
                        <div class="miniCartBodyItemFlexCol">
                            <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                            <button class="miniCartBodyItemRemove">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.5 14.5L9.5 11.5" stroke="currentColor" stroke-linecap="round"/>
                                    <path d="M14.5 14.5L14.5 11.5" stroke="currentColor" stroke-linecap="round"/>
                                    <path d="M3 6.5H21C19.5955 6.5 18.8933 6.5 18.3889 6.83706C18.1705 6.98298 17.983 7.17048 17.8371 7.38886C17.5 7.89331 17.5 8.59554 17.5 10V15.5C17.5 17.3856 17.5 18.3284 16.9142 18.9142C16.3284 19.5 15.3856 19.5 13.5 19.5H10.5C8.61438 19.5 7.67157 19.5 7.08579 18.9142C6.5 18.3284 6.5 17.3856 6.5 15.5V10C6.5 8.59554 6.5 7.89331 6.16294 7.38886C6.01702 7.17048 5.82952 6.98298 5.61114 6.83706C5.10669 6.5 4.40446 6.5 3 6.5Z" stroke="currentColor" stroke-linecap="round"/>
                                    <path d="M9.5 3.50024C9.5 3.50024 10 2.5 12 2.5C14 2.5 14.5 3.5 14.5 3.5" stroke="currentColor" stroke-linecap="round"/>
                                </svg>
                            </button>
                         
                        </div>
                    </div>
                </div>
                <div class="miniCartBodyItemFlex">

                <div class="miniCartBodyItemQuantity">
                        <button class="miniCartBodyItemQuantityMinus">
                            <svg width="7" height="2" viewBox="0 0 7 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.52871 1.69942H0.00105893V6.87711e-06H6.52871V1.69942Z" fill="#333230"/>
                            </svg>
                        </button>
                        <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                        <button class="miniCartBodyItemQuantityPlus">
                            <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.95572 8.06829H3.28807V4.86005H0.000427285V3.1924H3.28807V4.93686e-05H4.95572V3.1924H8.24337V4.86005H4.95572V8.06829Z" fill="#333230"/>
                            </svg>
                        </button>
                    </div>
                     ${discountHTML()}
                 </div>
               
                
                ${upgradeHTML()}
            </div>
        `);

    });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.dataset.key;

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // line item and its supplemental data, used to resync the selling plan when the quantity changes
        const item = cart.items.find(cartItem => cartItem.key === key);
        const supplementData = cartData[key];

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // same as the PDP: the new quantity picks a quantity selector tier, and that tier's
            // default cadence picks the selling plan - matched by name since plan ids are per variant
            let cadencePlan = null;
            if (quantity > 0 && item?.selling_plan_allocation) {
                const selector = findMatchingQuantitySelector(supplementData?.quantity_selectors, quantity);
                cadencePlan = getSellingPlanForSelector(supplementData?.selling_plan_allocations, selector);
            }

            // swap the plan alongside the quantity when the tier calls for a different cadence
            if (cadencePlan && cadencePlan.id !== item.selling_plan_allocation.selling_plan.id) {
                cart = await changeCart({id: key, quantity: quantity, selling_plan: cadencePlan.id});
            } else {
                // update cart in shopify
                cart = await updateCart({
                    updates: {
                        [key]: quantity
                    }
                });
            }

            // update active body
            await openCart(true);
        }

        /**
         * Change subscription plan function
         * @param key
         * @param quantity
         * @param sellingPlan
         * @returns {Promise<void>}
         */
        async function changePlan(key, quantity, sellingPlan) {
            document.querySelector("#miniCartContent").classList.add("loading");
            cart = await changeCart({id: key, quantity: quantity, selling_plan: sellingPlan});
            await openCart(true);
        }

        // upgrade to subscription
        element.querySelector(".planUpgrade")?.addEventListener("click", function () {
            changePlan(this.dataset.key, parseInt(this.dataset.quantity), parseInt(this.dataset.plan));
        });

        // change frequency
        element.querySelector(".miniCartBodyItemPlanFrequencySelect")?.addEventListener("change", function () {
            changePlan(this.dataset.key, parseInt(this.dataset.quantity), parseInt(this.value));
        });
    });

    // GIFTS
    const gifts = getEligibleGifts(cartData);

    // show each gift
    gifts.forEach((gift) => {
        // gifts without an original price metafield show no value tag
        let tagHTML = "";
        if (gift.compare_price) {
            tagHTML = `<div class="miniCartBodyGiftTag"><s>${price(gift.compare_price, true)}</s>&nbsp;$0</div>`;
        }

        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyGift">
            ${tagHTML}
                <img class="miniCartBodyGiftImg" src="${gift.image}" alt="Gift" >
                <div class="miniCartBodyGiftBody">
                    <div class="miniCartBodyGiftTitle">${gift.title}</div>
                    <div class="miniCartBodyGiftDesc">${gift.description}</div>
                </div>
            </div>
        `);
    })

    // upsell only applies when exactly one fabric spray is in cart - upgrade replaces it
    const fabricSprayID = 9231323627747;
    const fabricSprayItems = cart.items.filter(item => item.product_id === fabricSprayID);

    // sum quantity across all fabric spray line items (different variants count together)
    let fabricSprayQty = 0;
    fabricSprayItems.forEach(item => {
        fabricSprayQty += item.quantity;
    });

    // only eligible when there's exactly one fabric spray in the cart
    let fabricSprayInCart = null;
    if (fabricSprayQty === 1) {
        fabricSprayInCart = fabricSprayItems[0];
    }

    document.querySelectorAll(".miniCartUpsellItem").forEach(element => {
        // no fabric spray to upgrade from - hide the upsell
        if (!fabricSprayInCart) {
            element.classList.remove("active");
            return;
        }

        // upsell product already in cart - hide it
        const upsellProductID = parseInt(element.dataset.product);
        if (cart.items.find(item => item.product_id === upsellProductID)) {
            element.classList.remove("active");
            return;
        }

        // match the fabric spray's subscription/OTP state
        const isSubscription = !!fabricSprayInCart.selling_plan_allocation;

        // pick the matching upsell price for the active mode
        const upsellOtpPrice = parseInt(element.dataset.otpPrice);
        const upsellSubPrice = parseInt(element.dataset.subPrice || element.dataset.otpPrice);
        const upsellPrice = isSubscription ? upsellSubPrice : upsellOtpPrice;

        // attach selling plan when subscribing, otherwise clear it so ATC adds OTP
        if (isSubscription && element.dataset.subPlan) {
            element.dataset.plan = element.dataset.subPlan;
        } else {
            delete element.dataset.plan;
        }

        // remember which line item to remove on ATC
        element.dataset.replaceKey = fabricSprayInCart.key;

        // show only the upgrade delta vs fabric spray
        element.querySelector(".miniCartUpsellItemWrapBodyPrice").textContent = `+ ${price(upsellPrice - fabricSprayInCart.price, true)}`;

        element.classList.add("active");
    });

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellItem.active").length === 0) {
        document.querySelector("#miniCartUpsell").classList.remove("active");
    }

    // add protection price to ATC button if checked
    if (document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.checked) {
        document.querySelector("#miniCartFooterTotalPrice").textContent = price(cart.items_subtotal_price + cartSettings.protection_upsell.variants[0].price, true);
    } else {
        document.querySelector("#miniCartFooterTotalPrice").textContent = price(cart.items_subtotal_price, true);
    }
}

/**
 * Find the quantity selector tier that matches a line quantity
 * Exact match wins; otherwise fall back to the highest tier so an "out of range" quantity still resolves
 * @param {Array} selectors
 * @param {number} quantity
 * @returns {Object|null}
 */
function findMatchingQuantitySelector(selectors, quantity) {
    if (!selectors || selectors.length === 0) {
        return null;
    }
    const exact = selectors.find(selector => parseInt(selector.quantity) === quantity);
    if (exact) {
        return exact;
    }
    return selectors.reduce((highest, selector) => parseInt(selector.quantity) > parseInt(highest.quantity) ? selector : highest);
}

/**
 * Find the selling plan on a variant that matches the tier's default cadence
 * Matches by plan name since the plan ids differ per variant. Returns null when the tier has no cadence or nothing matches
 * @param {Array} sellingPlans variant's selling_plan_allocations plans
 * @param {Object|null} selector quantity selector tier
 * @returns {Object|null}
 */
function getSellingPlanForSelector(sellingPlans, selector) {
    if (!sellingPlans || sellingPlans.length === 0 || !selector?.default_subscription_cadence) {
        return null;
    }
    const cadence = selector.default_subscription_cadence.trim();
    return sellingPlans.find(plan => plan.name.trim() === cadence) || null;
}

/**
 * Collect the unique gifts the current cart qualifies for
 * @param {Object} cartData supplemental cart data keyed by line item key
 * @returns {Array}
 */
function getEligibleGifts(cartData) {
    const gifts = [];

    // check if any cart item has a gift
    cart.items.forEach(function (item) {
        // discounts can split the same variant across multiple lines - sum its quantity across the whole cart
        let variantQuantity = 0;
        cart.items.forEach(cartItem => {
            if (cartItem.variant_id !== item.variant_id) {
                return;
            }
            variantQuantity += cartItem.quantity;
        });

        // gifts live on the quantity selector tiers - use the highest tier the quantity has reached
        let selector = null;
        cartData[item.key]?.quantity_selectors?.forEach(q => {
            const tierQuantity = parseInt(q.quantity);
            if (tierQuantity <= variantQuantity && (!selector || tierQuantity > parseInt(selector.quantity))) {
                selector = q;
            }
        });
        const gift = selector?.gift;

        // Criteria:
        // Only add unique gifts (no duplicates)
        // If requires_subscription is true, the cart item must have a selling plan
        // Item must have reached the required quantity
        const isUnique = gift && !gifts.find(g => g.id === gift.id);
        const meetsSubscriptionReq = !gift?.requires_subscription || item.selling_plan_allocation;
        const meetsQuantityReq = !gift?.required_quantity || variantQuantity >= gift.required_quantity;

        if (isUnique && meetsSubscriptionReq && meetsQuantityReq) {
            gifts.push(gift);
        }
    });

    return gifts;
}

// Add Upsell function
document.querySelectorAll('.miniCartUpsellItemWrapATC').forEach(function (element) {
    element.addEventListener("click", async function () {
        const upsellItem = this.closest('.miniCartUpsellItem');
        const variantID = upsellItem.dataset.variant;
        const replaceKey = upsellItem.dataset.replaceKey;

        // start loading animation
        document.querySelector("#miniCartContent").classList.add("loading");

        // build the line item, attaching the selling plan if we're in subscription mode
        const newItem = {
            quantity: 1,
            id: variantID,
        };
        if (upsellItem.dataset.plan) {
            newItem.selling_plan = upsellItem.dataset.plan;
        }

        // add the upsell
        await addProduct({items: [newItem]});

        // remove the fabric spray we're upgrading from
        if (replaceKey) {
            await updateCart({updates: {[replaceKey]: 0}});
        }

        // remove loading animation
        this.classList.remove("loading");

        await openCart();
    });
});


// listen for protection plan switch
document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.addEventListener("change", async function () {
    await openCart(true);
});

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
    });
});

// close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

// close cart on overlay click
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // formdata
    let formData = {
        items: []
    };

    // check if protection product is checked - if so atc
    if (document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.checked) {
        // add protection product
        formData.items.push({
            quantity: 1,
            id: cartSettings.protection_upsell.variants[0].id,
        });
    }

    // add any gift the cart qualifies for, flagged so it never renders as a real cart item
    const cartData = await fetch("/cart?view=supplemental-data").then(response => response.json());
    getEligibleGifts(cartData).forEach(gift => {
        console.log(gift);
        // the gift variant is optional on the metaobject - nothing to add without it
        if (!gift.variant_to_add) {
            return;
        }

        // skip gifts already in the cart
        if (cart.items.find(item => item.variant_id === gift.variant_to_add)) {
            return;
        }

        formData.items.push({
            quantity: gift.quantity_to_add,
            id: gift.variant_to_add,
            properties: {_free: true},
        });
    });

    // add to cart
    if (formData.items.length > 0) {
        await addProduct(formData);
    }

    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}